<template>
    <div>
        <v-tooltip bottom>
            <template
                v-slot:activator="{ on: tooltip }">
                <div v-on="{...tooltip}">
                    <v-btn
                        :disabled="disabled"
                        small
                        color="primary"
                        @click.stop="dialog = true"
                    >
                        <v-icon>mdi-key-plus</v-icon>
                    </v-btn>
                </div>
            </template>
            <span>{{tooltipText}}</span>
        </v-tooltip>
        <DragForm
            v-model="dialog"
        >
            <v-card width="400">
                <v-card-title>{{dialogTitle}}</v-card-title>
        
                <v-card-text>
                    <v-text-field
                        :label="fieldTitle"
                        v-model="keyTPK"
                        counter="32"
                        :append-icon="'mdi-close'"
                        @click:append="OnClear"
                        :rules="[rules.required, rules.valid, rules.len]"
                        :prepend-icon="'mdi-key-variant'"
                    />
                </v-card-text>
        
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="red darken-1"
                        text
                        @click="onCancel"
                    >
                    {{cancelText}}
                    </v-btn>
        
                    <v-btn
                        color="green darken-1"
                        text
                        @click="onOk"
                    >
                    {{okText}}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </DragForm>
    </div>    
</template>
<script>
import DragForm from '@/components/Forms/DragForm.vue';
import {notifyError, notifySuccess} from '@/services/notifications';
export default{
  components: {
    DragForm,
  },
  props:{
    disabled:{
      type: Boolean,
      default: false
    },
    kioskInfo:{
      type: Object,
      default: null
    }
  },
  data(){
    return {
      dialogMaxWidth:'500px',
      dialog: false,
      keyTPK: '',
      requiredLength: 32,
      permissibleChars: /^[A-F0-9]+$/,

      rules: {
        required: v => v.length != 0 || this.$t('ReuiredField'),
        len: v => v.length == this.requiredLength  || this.$t('kiosks.requiredLength') + ': ' + this.requiredLength,
        valid: v => v.match(this.permissibleChars) !== null || this.$t('kiosks.requiredChars') + ': ' + '\'A\'-\'F\' and \'0\'-\'9\'',
      },
    };
  },
  computed: {
    tooltipText(){
      return this.$t('kiosks.editKeyTPK');
    },
    dialogTitle(){
      return this.$t('kiosks.editKeyTPK');
    },
    fieldTitle(){
      return this.$t('kiosks.keyTPK');
    },
    cancelText(){
      return this.$t('Cancel');
    },
    okText(){
      return this.$t('Change');
    },
  },
  watch:{
    dialog(val){
      if(!val)
        this.keyTPK = '';
    }
  },
  methods:{
    onOk(){ 
      const tmp = Object.keys(this.rules);
      for(let i = 0; i < tmp.length; i++){
        if (this.rules[tmp[i]](this.keyTPK) !== true)
          return;
      }

      const info = { };
      info.TempField = this.keyTPK.length == 0 ? null : this.keyTPK;
      try{
        this.$axios.kiosks.changeKeyRTP(this.kioskInfo.kioskId, info);
        this.dialog = false;
        notifySuccess('', this.$t('Success'));
        this.$emit('ok');
      }
      catch(err){
        console.error(err);
        notifyError('', this.$t('Error') + err);
      }
    },
    onCancel(){
      this.$emit('cancel');

      this.dialog = false;
    },
    OnClear(){
      this.keyTPK='';
    },
  }
};
</script>